import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  NgSelectOption,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ModalService } from '@core/services/modal.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { DatePickerComponent } from '@shared/components/ui/date-picker/date-picker.component';
import { InputComponent } from '@shared/components/ui/input/input.component';
import { SelectComponent } from '@shared/components/ui/select/select.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import {
  faCalendar,
  faEye,
  faPenToSquare,
  faTrashCan,
  faChevronLeft,
  faAngleRight,
  faFilter,
  faCircleCheck,
  faRightToBracket,
  faCircleExclamation,
  faDownload,
} from '@fortawesome/pro-light-svg-icons';
import { faArrowRight, faSort } from '@fortawesome/pro-solid-svg-icons';
import { fechaPresenteFormatDate } from '@core/utils/validators/date-range.validator';
import { controlValueChanges, markAbstractControlDirty, markAbstractControlTouched, removeTime, } from '@core/utils/functions';
import { TableComponent } from '@shared/components/ui/table/table.component';
import { PaginationComponent } from '@shared/components/ui/pagination/pagination.component';
import { IconComponent } from '@shared/components/ui/icon/icon.component';
import { CollapseComponent } from '@shared/components/ui/collapse/collapse.component';
import { ToggleComponent } from '@shared/components/ui/toggle/toggle.component';
import { ChipErrorComponent } from '@shared/components/ui/chip-error/chip-error.component';
import { ProgressTabComponent } from '@shared/components/ui/progress-tab/progress-tab.component';
import { TabService } from '@core/services/tab.service';
import { Dialog } from '@core/models/dialog.interface';
import Messages from '@core/utils/functions/messages.function';

// import { NewPasswordComponent } from "../pages/new-password/new-password.component";

@Component({
  selector: 'app-example',
  standalone: true,
  imports: [
    ButtonComponent,
    InputComponent,
    SelectComponent,
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    NzButtonModule,
    NzSelectModule,
    DatePickerComponent,
    NzDatePickerModule,
    FontAwesomeModule,
    TableComponent,
    PaginationComponent,
    IconComponent,
    CollapseComponent,
    ToggleComponent,
    ChipErrorComponent,
    ProgressTabComponent,
  ],
  templateUrl: './example.component.html',
  styleUrl: './example.component.scss',
})
export default class ExampleComponent implements OnInit, AfterViewInit {
  @ViewChild('paginacionLog') paginacionLog!: ElementRef;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      this.paginacionLog.nativeElement.getAttribute('hiddenPagination') ==
      'true'
    ) {
      const pos =
        (document.documentElement.scrollTop || document.body.scrollTop) +
        window.innerHeight;
      const max =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      if (pos === max) {
        // Aquí puedes ejecutar la acción que desees cuando el scroll llegue al final
        this.render.setStyle(
          this.paginacionLog.nativeElement,
          'transform',
          'translateY(100%)'
        );
      } else {
        this.render.setStyle(
          this.paginacionLog.nativeElement,
          'transform',
          'translateY(0%)'
        );
      }
    }
  }

  checkScrollAvailability() {
    if (
      this.paginacionLog.nativeElement.getAttribute('hiddenPagination') ==
      'true'
    ) {
      const max =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const viewHeight = window.innerHeight;

      if (max <= viewHeight) {
        // Acción cuando no hay scroll
        this.render.setStyle(
          this.paginacionLog.nativeElement,
          'transform',
          'translateY(0%)'
        );
      }
    }
  }

  //Icons
  faCalendar = faCalendar;
  faEye = faEye;
  faSort = faSort;
  faPenToSquare = faPenToSquare;
  faTrashCan = faTrashCan;
  faChevronLeft = faChevronLeft;
  faAngleRight = faAngleRight;
  faFilter = faFilter;
  faDownload = faDownload;

  // Array inicial con un solo objeto
  rows: any[] = [
    {
      FullName: 'James Jameson Gert Pérez',
      Email: 'usermail01@domain.com',
      Client: '00024 - Business Example',
    },
  ];

  errorMessage!: string;

  form!: FormGroup;
  parentForm!: FormGroup;
  formPagination!: FormGroup;

  opcionesPaginacion: FormControl = new FormControl(10);
  listadoPaginacion = [1, 10, 15, 20, 25, 30, 35, 40, 45];
  editingPagination!: any;
  scrollTemp = 0;
  scrollPos: number = 0;

  loading!: boolean;

  ofertaBase!: any;
  count: number = 2;

  get paginacion(): any {
    return this.formPagination.get('PAGINA_ACTUAL');
  }
  get totalPaginas(): any {
    return this.formPagination.get('TOTAL_PAGINAS');
  }
  get registrosPorPagina(): any {
    return this.formPagination.get('REGISTROS_POR_PAGINA');
  }

  // date picker

  /**
   * Objeto donde se validarán si los campos del formulario son obligatorios
   * aplica para:
   * * Fecha inicial
   * * Fecha final
   */
  isRequired: any = {
    fechaInicial: false,
    fechaFinal: false,
  };

  //! Inicio Configuracion Date Pickers
  dateFormat = 'dd-MM-yyyy';

  disabledStartDate = (endValue: Date): boolean => {
    if (!endValue || !this.form.value.fechaFinal) {
      if (
        removeTime(endValue).getTime() >
        removeTime(new Date()).getTime()
      ) {
        return true;
      } else {
        return false;
      }
    } else if (
      removeTime(endValue).getTime() >
      removeTime(this.form.value.fechaFinal).getTime()
    ) {
      return true;
    } else {
      return false;
    }
  };

  disabledEndDate = (startValue: Date): boolean => {
    if (!startValue || !this.form.value.fechaInicial) {
      return false;
    } else if (
      removeTime(startValue).getTime() <
      removeTime(this.form.value.fechaInicial).getTime()
    ) {
      return true;
    } else {
      return false;
    }
  };

  addValidatorDateStartEnd() {
    if (this.form.get('tipoFecha')!.value) {
      if (this.form.get('fechaInicial')!.value) {
        controlValueChanges(false, [this.form.get('fechaFinal')], false);
        this.isRequired.fechaInicial = true;
        this.isRequired.fechaFinal = false;
      } else if (this.form.get('fechaFinal')!.value) {
        controlValueChanges(false, [this.form.get('fechaInicial')], false);
        this.isRequired.fechaInicial = false;
        this.isRequired.fechaFinal = true;
      } else {
        controlValueChanges(
          true,
          [this.form.get('fechaInicial'), this.form.get('fechaFinal')],
          false
        );
        this.isRequired.fechaInicial = true;
        this.isRequired.fechaFinal = true;
      }
    } else {
      controlValueChanges(
        false,
        [this.form.get('fechaInicial'), this.form.get('fechaFinal')],
        false
      );
      this.isRequired.fechaInicial = false;
      this.isRequired.fechaFinal = false;
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private _messages: Messages,
    private render: Renderer2,
    private tabService: TabService
  ) { }

  ngAfterViewInit(): void {
    // detect scroll
    this.checkScrollAvailability();

    // tab
    this.count = 2;
  }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      name: [''],
      intermediario: [''],
      apellido: [{ value: '', disabled: true }],
      telefono: ['', [Validators.required]],
      files: [null, [Validators.required]],
      opcion: [''],
      opcionDos: [''],
      opcionTres: [{ value: '', disabled: true }],
      opcionCuatro: ['', [Validators.required]],
      fechaInicial: [null, [fechaPresenteFormatDate()]],
      fechaFinal: [null, [fechaPresenteFormatDate()]],
      fechaDisabled: [{ value: null, disabled: true }],
      fechaError: [null, [Validators.required]],
      check: [false, [Validators.requiredTrue]],
      afCard: [null],
      afCardInvalid: [false, [Validators.requiredTrue]],
    });

    this.formPagination = this.formBuilder.group({
      PAGINA_ACTUAL: [1],
      REGISTROS_POR_PAGINA: [15],
      TOTAL_PAGINAS: [1],
      TOTAL_REGISTROS: [null],
    });

    this.parentForm = this.formBuilder.group({
      name: [''],
      phone: [''],
      email: [''],
    });

    //!  Limits and Transfers Proposal
    this.formTransfers = this.formBuilder.group({});

    // Define la longitud deseada del array
    const desiredLength = 18;

    for (let i = 1; i < desiredLength; i++) {
      // Copia el último objeto del array para crear uno nuevo
      let newItem = { ...this.rows[this.rows.length - 1] };

      // Asigna un nuevo ID_FORM
      newItem.ID_FORM = (parseInt(newItem.ID_FORM) + 1).toString();

      // Si el índice es impar, modifica los valores
      if (i % 2 !== 0) {
        newItem.FullName = 'Hasar Glis Castro Lopez';
        newItem.Email = 'user_mail@domain.com';
        newItem.Client = '00012 - Business Example';
      } else {
        newItem.FullName = 'James Jameson Gert Pérez';
        newItem.Email = 'usermail01@domain.com';
        newItem.Client = '00024 - Business Example';
      }
      // Agrega el nuevo objeto al array
      this.rows.push(newItem);
    }
  }


  onFileSelected(event: HTMLElement): void {
    //const input = event.target as HTMLInputElement;
    const input: any = event;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Limpiar mensajes de error y vista previa anterior
      this.errorMessage = '';
      this.form.get('files')?.reset();

      // Validar tipo de archivo
      if (file.type !== 'image/png') {
        this.errorMessage = 'Only PNG images are allowed.';
        markAbstractControlDirty(this.form.get('files'));
        return;
      }

      // Validar tamaño máximo del archivo (4MB)
      const maxSizeInMB = 4;
      if (file.size > maxSizeInMB * 1024 * 1024) {
        this.errorMessage = `The file must not exceed ${maxSizeInMB} MB`;
        markAbstractControlDirty(this.form.get('files'));
        return;
      }

      // Leer el archivo y generar la vista previa
      const reader = new FileReader();
      reader.onload = (e: any) => {

        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          const width = img.width;
          const height = img.height;

          if (width !== 600 || height !== 600) {
            this.errorMessage = 'Image size has to be 600px X 600px.';
            input.value = ''; // Reiniciar el input de archivo
            markAbstractControlDirty(this.form.get('files'));
            return;

          }
          // Guardar el valor base64 en el FormControl
          const imageBase64 = reader.result;

          // guardar nombre del archivo
          this.form.get('files')?.setValue({ value: input.files[0].name, base64: imageBase64 });
          /* .split('.').slice(0, -1).join('.') */
        }
      };
      reader.readAsDataURL(file);
    }
  }


  async changeSelect(event: any) {
    this.loading = true;
    // await this.filtrar();
    this.loading = false;
  }

  async changeInput(value: any) {
    if (value > 0 && value <= this.formPagination.get('TOTAL_PAGINAS')!.value) {
      if (this.editingPagination != value) {
        this.loading = true;
        // await this.filtrar()
        this.loading = false;
      }
    } else {
    }
  }

  async changePage(futurePage: any) {
    let data: number = Number(futurePage);
    if (data > 0 && data <= this.formPagination.get('TOTAL_PAGINAS')!.value) {
      this.loading = true;
      this.formPagination.get('PAGINA_ACTUAL')!.setValue(data);
      //await this.filtrar()
      this.loading = false;
    }
  }

  async next() {
    let nextPage = Number(this.formPagination.get('PAGINA_ACTUAL')!.value) + 1;
    if (nextPage <= this.formPagination.get('TOTAL_PAGINAS')!.value) {
      this.loading = true;
      this.formPagination.get('PAGINA_ACTUAL')!.setValue(nextPage);
      //await this.filtrar()
      this.loading = false;
    }
  }

  async prev() {
    let prevPage = Number(this.formPagination.get('PAGINA_ACTUAL')!.value) - 1;
    if (prevPage > 0) {
      this.loading = true;
      this.formPagination
        .get('PAGINA_ACTUAL')!
        .setValue(this.formPagination.get('PAGINA_ACTUAL')!.value - 1);
      // await this.filtrar()
      this.loading = false;
    }
  }

  activeTab: number = 1;

  setActiveTab(tab: number) {
    this.activeTab = tab;
  }

  nextStep() {
    this.tabService.nextStep();
  }

  prevStep() {
    this.tabService.prevStep();
  }

  //Modals
  succes() {
    let data: Dialog = {
      icon: {
        name: faCircleCheck,
        container: 'bg-success color-success',
      },
      title: 'Register deleted!',
      confirmButton: { text: 'Ok', icon: faCircleCheck },
      data: {},
    };


    this._messages.showMessage(data).subscribe({
      next: (response) => {
      },
    });
  }

  delete() {
    let data: Dialog = {
      icon: {
        name: faTrashCan,
        container: 'bg-danger color-danger',
      },
      title: 'Do you want to delete <br> this register?',
      gridButton: 2,
      confirmButton: { text: 'Delete' },
      cancelButton: { text: 'Back', icon: faChevronLeft },
      padding: '3rem 1.5rem 1.5rem',
      data: {},
    };
    this._messages.showMessage(data).subscribe({
      next: (response) => {
      },
    });
  }

  holdUp() {
    let data: Dialog = {
      icon: {
        name: faCircleExclamation,
        container: 'bg-warning color-warning',
      },
      title: 'Hold Up!',
      text: 'If you go back, the current progress will be lost',
      subText: 'Do you want to proceed?',
      confirmButton: { text: 'Yes', icon: faCircleCheck },
      cancelButton: { text: 'No', icon: faChevronLeft },
      padding: '3rem 1.5rem 1.5rem',
      data: {},
    };

    this._messages.showMessage(data).subscribe({
      next: (response) => {
      },
    });
  }

  detected() {
    let data: Dialog = {
      icon: {
        name: faCircleExclamation,
        container: 'bg-warning color-warning',
      },
      title: 'Unsaved changes have <br> been detected',
      text: 'Do you want to save before exiting?',
      confirmButton: { text: 'Save and Exit', icon: faCircleCheck },
      exitButton: { text: 'Exit without Saving', icon: faRightToBracket },
      cancelButton: { text: 'Back', icon: faChevronLeft },
      padding: '3rem 1.5rem 1.5rem',
      data: {},
    };

    this._messages.showMessage(data).subscribe({
      next: (response) => {
      },
    });
  }

  //Card o modal de Voucher Programs
  //icon
  faArrowRight = faArrowRight;

  //form
  formTransfers!: FormGroup;
}
